module.exports = __webpack_public_path__ + "static/application-a5ef1d2bb96b8567f95639cb37d6adca.png";